// removed by extract-text-webpack-plugin
module.exports = {"sbox-modal":"SearchboxModal_sbox-modal---sb","sboxModal":"SearchboxModal_sbox-modal---sb","searchbox":"SearchboxModal_searchbox---sb","close-btn":"SearchboxModal_close-btn---sb","closeBtn":"SearchboxModal_close-btn---sb","mobile-view":"SearchboxModal_mobile-view---sb","mobileView":"SearchboxModal_mobile-view---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchboxModal/styles.less
// module id = 1666
// module chunks = 0